const enum StepTaskPriority {
  Low = 0,
  Medium = 1,
  High = 2
}

export default StepTaskPriority;
